exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar-container {\n  min-width: 50px;\n  min-height: 50px;\n  max-width: 50px;\n  max-height: 50px;\n  border-radius: 10%;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #b8b8b8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 1px 1px 1px #e2e2e2c4; }\n\n.avatar-image {\n  margin: auto;\n  width: 80%; }\n\n.avatar-image svg {\n  height: 40px;\n  width: 40px;\n  filter: drop-shadow(1px 1px 1px #e2e2e2c4); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/views/avatar/avatar.scss
// module id = 1032
// module chunks = 0